var render = function render(_c,_vm){return (_vm.$options.customRender(_vm.props))?_c('div',{staticClass:"foo"},[(!_vm.$options.getSrcImg(_vm.props))?_c('el-avatar',{attrs:{"size":"small","src":"/static/images/avatar-2.jpg"}}):_c('el-avatar',{attrs:{"size":"small","src":_vm.$options.getSrcImg(_vm.props)}}),_c('span',[_vm._v(_vm._s(_vm.$options.customRender(_vm.props)))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }